import React, { Component } from 'react';
import styled, { withTheme } from 'styled-components';
import colors from '../../utils/colors';
import { RegularText } from '../../utils/typography';
import { Row } from './layoutUtils';
import MaterialIcon from './icons/MaterialIcon';

type Props = {
  name?: string;
  label?: React.ReactNode;
  color?: string;
  checked?: boolean;
  onMouseDown?: any;
  onChange?: (clickData?: any, event?: any) => void;
  clickData?: any;
  disabled?: boolean;
  className?: string;
  labelStyle?: any;
  theme: any;
  iconTextColor?: string;
  breakLine?: boolean;
  indeterminate?: boolean;
  /** A smaller box, for labels in smaller type (the sidebar's connected calendars). */
  small?: boolean;
};

class CheckBox extends Component<Props> {
  handleClick = e => {
    const { onChange, disabled, clickData } = this.props;
    if (onChange && !disabled) onChange(clickData, e);
  };

  render() {
    const {
      name,
      label,
      color,
      checked,
      disabled,
      className,
      labelStyle,
      onMouseDown,
      theme = {},
      iconTextColor,
      breakLine,
      indeterminate,
      small
    } = this.props;

    return (
      <Container
        data-cy={name}
        className={className}
        disabled={disabled}
        onClick={this.handleClick}
        onMouseDown={onMouseDown}
      >
        <Wrapper color={indeterminate || checked ? iconTextColor : ''} $small={small}>
          <MaterialIcon
            size={small ? 16 : undefined}
            name={checked ? 'check_box' : indeterminate ? 'indeterminate_check_box' : 'check_box_outline_blank'}
            color={disabled ? theme.captures : !checked && !indeterminate ? theme.textColor : color || colors.primaryPurple}
            style={{ cursor: disabled ? 'not-allowed' : 'pointer' }}
          />
        </Wrapper>
        {label && (
          <Label
            style={labelStyle}
            color={disabled ? theme.captures : undefined}
            strong={indeterminate || checked}
            breakLine={breakLine}
            $small={small}
            className={'checkbox-label'}
          >
            {label}
          </Label>
        )}
      </Container>
    );
  }
}

const Label = styled(RegularText)<{ breakLine?: boolean; $small?: boolean }>`
  flex: 1;
  transition: all 0.2s ease;
  margin-left: ${props => (props.$small ? 6 : 8)}px;
  text-overflow: ellipsis;
  ${props => !props.breakLine && 'white-space: nowrap;'};
  overflow: hidden;
  line-height: 1.4;
`;

const Container = styled(Row)<{ disabled?: boolean }>`
  cursor: ${props => (props.disabled ? 'not-allowed' : 'pointer')};
  overflow: hidden;
  min-width: 20px;
  align-items: flex-start;
  &:hover {
    ${props =>
      !props.disabled &&
      `${Label} {
          opacity: 0.75;
      }`}
  }
  transition: all 0.2s ease;
`;

// The icon's box is drawn a little inside its square, so the square sits under it and is moved up and left to match.
const Wrapper = styled.div<{ color?: string; $small?: boolean }>`
  ${props => props.color && `background-color: ${props.color}`};
  position: relative;
  flex-shrink: 0;
  width: ${props => (props.$small ? 13 : 16)}px;
  height: ${props => (props.$small ? 13 : 16)}px;
  border-radius: 2px;
  margin-left: 1px;
  margin-top: ${props => (props.$small ? 3 : 1)}px;
  i {
    position: absolute;
    top: ${props => (props.$small ? -1.5 : -2)}px;
    left: ${props => (props.$small ? -1.5 : -2)}px;
  }
`;

export default withTheme(CheckBox);
